export default __webpack_public_path__ + "static/ux.ananas-e733a8767da4c38d2e36e6cc82c402e1.png";